import React, {Component} from 'react';
import {Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Row,} from 'reactstrap';
import {Line} from 'react-chartjs-2';
import moment from 'moment';
import {connect} from 'react-redux';
import {closeAlert} from '../../../actions/commonsActions';
import {USER_ROLES,} from '../../../helpers/constants';

// Datetime picker plugin file
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';

import 'react-table/react-table.css';
import {getColorsObject} from "../../../helpers/getRandomRgb";
import nanoid from "nanoid";
import {I18n} from "../../../I18n/components/Promo/PromoSummaryStat";
import {
    fetchBasicOfferPrefs,
    fetchLocalizedOfferPrefs,
    fetchOffers,
    fetchOffersStat
} from '../../../actions/promoActions';
import {push} from "connected-react-router";
import './offerStatPage.css';
import OfferStatList from '../OfferStatList/OfferStatList';
import {debounce} from '../../../helpers/debounce';

//Line chart
let lineData = {
    labels: [1, 2, 3, 4, 5, 6, 7, 8],
    datasets: [{
        label: 'Name',
        borderWidth: 1,
        backgroundColor: 'rgba(94,114,228,.1)',
        borderColor: 'rgb(94,114,228)',
        pointBorderColor: 'rgb(94,114,228)',
        pointBackgroundColor: 'rgb(94,114,228)',
        data: [0, 15, 6, 11, 25, 9, 18, 24]
    }]
};

class OfferStatPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
            color: getColorsObject(0.1),
            loading: true,
            currentPage: 0,
            statistics: [],
            offers: [],
            filters: [],
            filter: '',
            appLabels: null,
            colors: []
        };
        //this.debounceFetch = debounce(this.fetchPaginatedData, 500);

    }

    componentDidMount() {
        (async () => {
            try {
                const {location} = this.props;
                await this.props.fetchOffers({
                    page: 0,
                }).then(res => {
                    this.setState({
                        offers: res.data,
                        appLabels: res.data && res.data.length ? (
                            res.data.map(app => app.appLabel).join(',')
                        ) : null,
                    });
                    return this.props.fetchOffersStat({
                        traderCompanyId: this.props.company.id,
                        appLabels: this.state.appLabels,
                        dateFrom : this.state.dateFrom,
                        dateTo: this.state.dateTo
                    })
                }).then(res => {
                    this.setState({
                        statistics: this.props.stat && this.props.stat.items ? this.props.stat.items : [],
                        colors: this.props.stat.items.map(() => getColorsObject(0.1))
                    })
                });
                this.props.fetchLocalizedOfferPrefs({
                    lang: this.props.lang
                });
                this.props.fetchBasicOfferPrefs();
            } catch (error) {
                console.error(error)
            }
        })();
    }

    fetchPaginatedData = async currentPage => {
        const filters = [
            ...this.state.filters.length ? this.state.filters : false,
        ];
        await this.props.fetchOffersStat({
            dateFrom : this.state.dateFrom,
            dateTo: this.state.dateTo,
            traderCompanyId: this.props.company.id,
            appLabels: this.state.appLabels,
            filters,
            sorting: this.state.sorting ? this.state.sorting : false,
            page: currentPage
        });
        await this.setState({
            currentPage,
            colors: this.props.stat.items.map(() => getColorsObject(0.1))
        });
    }

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };


    onFilterClick = (name, value) => {
        this.setState(state => {
            const filteredElemIndex = state.filters.findIndex(item => item.name === name);
            let filters = [...state.filters];
            if (filteredElemIndex !== -1) {
                if (value && value !== '') {
                    filters[filteredElemIndex].name = name;
                    filters[filteredElemIndex].value = value;
                } else {
                    filters = filters.filter(elem => elem.name !== name);
                }
            } else {
                filters = [...state.filters, {name : name, value: value}]
            }
            return {
                [`${name}`]: value,
                filters: filters
            }
        })
        //this.debounceFetch(0)
    };

    dateToTimeChange = moment => {
        this.setState({
            dateTo: moment.format('YYYY-MM-DD')
        })
    };

    dateFromTimeChange = moment => {
        this.setState({
            dateFrom: moment.format('YYYY-MM-DD')
        })
    };

    getFiltered = async () => {
        this.fetchPaginatedData(0);
    };

    clearFilters = () => {
        this.setState({
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
            filters: [],
            filter: '',
            sorting: false,
            //order: 'ASC',
            colors: this.state.statistics.map(() => getColorsObject(0.1))
        }, () =>{
            this.fetchPaginatedData(0);
        })
    };

    renderGraf = () => {
        let labels = [];
        let maxDataValue = null;
        let dataSets = [];
        const {stat, lang} = this.props;
        if (stat && stat.items) {
            labels = [];
            maxDataValue = null;
            dataSets = stat.items.reduce((res, item, i) => {
                const { chartPoints } = item;
                if (chartPoints && chartPoints.length) {
                    const color = this.state.colors[i];
                    const data = chartPoints.map(elem => elem.value);
                    const maxValue = Math.max(data);
                    maxDataValue = maxValue > maxDataValue ? maxValue : maxDataValue;
                    const dataSet = {
                        label: item.offer.appLabel,
                        data: data,
                        //fill: false,
                        borderWidth: 1,
                        backgroundColor: color ? color.opacityColor : '',
                        borderColor: color? color.mainColor : '',
                        pointBorderColor: color? color.mainColor : '',
                        pointBackgroundColor: color? color.mainColor : '',
                    };
                    res.push(dataSet);
                }
                return res;
            },[]);
            if (stat.items.length && stat.items[0].chartPoints && stat.items[0].chartPoints.length) {
                labels = stat.items[0].chartPoints.reduce((res, chart) => {
                    res.push(chart.label);
                    return res
                }, [])
            }
        }
        return (
            <div>
                <Row className="offerstatpage-graf">
                    <Col lg="12">
                        <div className="campaign ct-charts">
                            <div className="chart-wrapper"
                                 style={{ width: '100%', margin: '0 auto', height: 350 }}>
                                <Line
                                    data={{
                                        datasets: dataSets,
                                        labels: labels
                                    }}
                                    datasetKeyProvider={() => `${nanoid()}`}
                                    options={{
                                        maintainAspectRatio: false,
                                        legend: {
                                            display: false,
                                            labels: { fontFamily: "Nunito Sans" }
                                        },
                                        scales: {
                                            yAxes: [{
                                                stacked: false,
                                                gridLines: { display: false },
                                                ticks: {
                                                    fontFamily: "Nunito Sans",
                                                    beginAtZero:true,
                                                    min: 0,
                                                    stepSize: (maxDataValue / 2).toFixed()
                                                }
                                            }],
                                            xAxes: [{
                                                stacked: false,
                                                gridLines: { display: false },
                                                ticks: {
                                                    fontFamily: "Nunito Sans",
                                                    stepSize: 1,
                                                    beginAtZero:true
                                                }
                                            }]
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg="12">
                        <FormGroup>
                            <Input
                                className="offerstatpage-filter"
                                type="text"
                                name="filter"
                                id="filter"
                                value={this.state.filter}
                                onChange={(e) =>
                                    this.onFilterClick('filter', e.target.value)}
                                placeholder={I18n[lang].title}
                            />
                            <Datetime
                                className="offerstatpage-data-filter"
                                locale="en-gb"
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{placeholder: `${I18n[lang].dateFrom}`, readOnly: true}}
                                onChange={this.dateFromTimeChange}
                                value={this.state.dateFrom ? moment(this.state.dateFrom).format('DD.MM.YYYY') : ''}
                            />
                            <Datetime
                                className="offerstatpage-data-filter date-to"
                                locale="en-gb"
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{placeholder: `${I18n[lang].dateTo}`, readOnly: true}}
                                onChange={this.dateToTimeChange}
                                value={this.state.dateTo ? moment(this.state.dateTo).format('DD.MM.YYYY') : ''}
                            />
                            <div className="offerstatpage-btn__group">
                                <Button
                                    color="primary"
                                    type="button"
                                    className="offerstatpage-btn btn-filter"
                                    onClick={this.getFiltered}
                                >
                                    {I18n[lang].filter}
                                </Button>
                                <Button
                                    color="primary"
                                    type="button"
                                    className="offerstatpage-btn btn-clear"
                                    onClick={this.clearFilters}
                                >
                                    {I18n[lang].resetFilter}
                                </Button>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    };

    render() {
        const {stats, lang} = this.props;
        const {loading} = this.props;
        const offerList = loading ? <div className="loading">Loading...</div> : <OfferStatList
            lang={this.props.lang}
            offers={this.props.offers}
            stat={this.props.stat.items}
            currentPage={this.state.currentPage}
            setCurrentPage={this.setCurrentPage}
            totalPages={this.props.pagination.totalPages}
        />

        return (
            <div className='OfferStatPage'>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-border-right mr-2"></i>{I18n[lang].offerDevStatTitle}
                        </div>
                    </CardTitle>
                    <CardBody>
                    {this.renderGraf()}
                    {offerList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchOffers: query => dispatch(fetchOffers(query)),
        fetchLocalizedOfferPrefs: query => dispatch(fetchLocalizedOfferPrefs(query)),
        fetchBasicOfferPrefs: () => dispatch(fetchBasicOfferPrefs()),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        fetchOffersStat: query => dispatch(fetchOffersStat(query))
    };
};

const mapStateToProps = state => ({
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    alert: state.alert,
    offers: state.offersList.offers,
    localizedOfferPrefs: state.localizedOfferPrefsList.prefs,
    basicOfferPrefs: state.basicOfferPrefsList.prefs,
    authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    lang: state.languageReducer.lang,
    stat: state.promoOffersStat.stat,
    pagination: state.promoOffersStat.pagination,
    loading: state.promoOffersStat.loading,
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferStatPage)



// WEBPACK FOOTER //
// ./src/components/Promo/OfferStatPage/OfferStatPage.js